<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';

    import {debounced, get, post} from '../../../utils.js';
    import {branchId, roles, currentNewElementButtonId, rolesTotalTime} from '../workspacesStore.js';
    import {slide} from 'svelte/transition';
    import Spinner from '../../Spinner.svelte';
    import ElementTypeIcon from '../../Element/ElementTypeIcon.svelte';
    import ElementStatus from './ElementStatus.svelte';
    import {onMount} from 'svelte';
    import {updateLocalElementInstance, addElementToLocalWorksequence, calculateRoleTotalTime} from './utils.js';
    import {sgettext} from '../../../i18n.js';

    import {
       activityVersion
    } from '../workspacesStore.js';

    export let item = {};
    export let searchElementsApi = `${PATH_PREFIX}/sw/api/elements_database/search/`;
    export let addElementToWorksequenceApi = `${PATH_PREFIX}/sw/api/builder/worksequence/{0}/add/element/{1}/`;
    export let createNew = () => {
    };


    let searchTerm = '';
    let loading = false;
    let elements = [];
    let component;
    let input = null;
    let adding = false;
    let buttonId = 'createNewElementButton';

    $: buttonId = `createNewElementButton${item ? item.id : ''}`;

    const handleInputChange = debounced(500, searchElements);

    function handleOnClick() {
        createNew(item, elements.length ? '' : searchTerm);
        currentNewElementButtonId.set(buttonId);
    }

    async function searchElements(event) {
        const url = `${searchElementsApi}?branchId=${$branchId}&keywords=${searchTerm}&worksequence_id=${item.id}&include_ancestor_branches=true`;
        if (searchTerm && searchTerm.length > 2) {
            loading = true;
            const response = await get(url);
            if (response.ok) {
                const data = await response.json();
                elements = data.results;
            }
            loading = false;
        } else {
            elements = [];
        }
    }

    async function handleSearchItemOnClick(event, element) {
        if (!adding) {
            const elementId = element.id;
            const worksequenceId = item.id;
            const roleId = item.role_id;
            const index = component.parentElement.dataset.index;
            const timestamp = Date.now();
            const elementInstance = {
                ...element,
                travel_time: 0,
                quantity: 1,
                step: '',
                x_coord: 0,
                y_coord: 0,
                z_coord: 0,
                id: timestamp
            };

            roles.set(addElementToLocalWorksequence($roles, roleId, worksequenceId, elementInstance));
            adding = true;
            const response = await addElementToWorksequence(elementId, worksequenceId, 0, 0, index);
            if (response.ok) {
                const result = await response.json();

                //update local copy
                const updated = updateLocalElementInstance($roles, roleId, worksequenceId, timestamp, result);
                roles.set(updated);
                rolesTotalTime.set(calculateRoleTotalTime(updated));
            }
            adding = false;
        }
    }

    async function addElementToWorksequence(elementId, worksequenceId, x, y, index) {
        const jsonData = {
            x,
            y,
            index
        };

        const apiUrl = addElementToWorksequenceApi
            .replace('{0}', worksequenceId)
            .replace('{1}', elementId);

        return await post(apiUrl, jsonData);
    }

    function clearSearchResult() {
        elements = [];
        searchTerm = '';
    }

    onMount(() => {
        input.focus();
    });
</script>

<style>
    .element {
        /* Limit text to only one line + truncate with ellipsis */
        /* https://css-tricks.com/line-clampin/ */
        /* https://dropshado.ws/post/1015351370/webkit-line-clamp */
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .wrapper {
        padding: 10px 15px 10px 35px;
        border: 1px solid #dee2e6;
    }

    .search-bar {
        display: grid;
        grid-template-columns: 25px 1fr auto;
        align-items: center;
    }

    input[type="text"] {
        border: none;
        padding: 3px;
        color: #454545;
    }

    input[type="text"]:focus {
        outline: none;
    }

    .icon {
        padding: 0 5px;
    }

    .search-result {
        font-size: 12px;
        color: #454545;
        list-style: none;
        padding: 0;
    }

    .search-result li {
        padding: 3px 5px;
        white-space: pre-wrap;
    }

    .search-result li:hover, .search-result li:hover:nth-child(odd) {
        background-color: #dee2e6;
    }

    .search-result li:nth-child(odd) {
        background-color: #f8f9fa;
    }

    .clear-results {
        cursor: pointer;
        color: #454545;
    }

    .clear-results:hover {
        color: #dd5900;
    }

    .btn.btn-link {
        width: auto;
        text-align: left;
        padding: 5px 0;
    }

    .btn-link:hover {
        text-decoration: none;
    }

    .fa5-plus-square {
        margin-right: 8px;
    }

    .disabled {
        pointer-events:auto;
        opacity:0.6;
    }
</style>

<div class="ignore wrapper static" on:contextmenu|preventDefault|stopPropagation>
    <div class="ignore search-bar" bind:this={component}>
        <i class="fa fa-search-plus" aria-hidden="true"></i>
        <input
            class="ignore"
            type="text"
            bind:value={searchTerm}
            bind:this={input}
            on:keyup={handleInputChange}
            placeholder={sgettext("$$SEARCH_ELEMENT_NAME$$")}/>
        <span class="icon">
    {#if loading}
        <Spinner size="small"/>
    {:else}
        {#if elements.length}
        <span
            on:click={clearSearchResult}
            class="clear-results"><i class="fas fa5-times-circle"></i>
        </span>
        {/if}
    {/if}
    </span>
    </div>
    {#if elements.length}
        <ol
            class="search-result"
            transition:slide="{{duration: 500}}"
        >
            {#each elements as element}
                {#if element.type === 'QUALITY' && (element.element_from_apm || $activityVersion?.activity_governance_type === 'APM Governed')}
                    <li class="element disabled"
                        title={sgettext('$$CANNOT_ADD_QUALITY_ELEMENTS_APM_GOVERNED$$')}
                        >
                        <ElementTypeIcon type={element.type}/>
                        <ElementStatus status={element.status}/>
                        {element.name}
                    </li>
                {:else}
                    <li class="element"
                        title={element.name}
                        on:click={event => handleSearchItemOnClick(event, element)}>
                        <ElementTypeIcon type={element.type}/>
                        <ElementStatus status={element.status}/>
                        {`${element.id}   ${element.name}`}
                        <span class="badge badge-pill badge-secondary" style="float: right;" title="{element.tags != '' ? element.tags : ''}">{ element.tags != '' ? sgettext('$$TAGS_1$$') : ''}</span>
                    </li>
                {/if}
            {/each}
        </ol>
    {/if}
    <div>
        <i class="fas fa5-plus-square" aria-hidden="true"></i>
        <button
            id={buttonId}
            class="ignore btn btn-link"
            on:click={handleOnClick}
        >{sgettext('$$CREATE_NEW_ELEMENT_1$$')}</button>
    </div>
</div>




